<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 ">
    <loading v-if="loading" />
    <div class="container mb-5 pb-5 vaillantCont">

			<div class="row justify-content-center">

        <div class="col-sm-12 col-md-12">
          <h3 class="Bold center pt-5 widthFull"><strong>Recupero Password</strong></h3>
        </div>

			<div class="col-sm-9 col-md-5 pt-4">

				<form class="forgot-password mt-3  pt-4 pb-4" id="forgot-form" @submit.prevent="forgot">



					<div v-if="!state" >
						<div class="form-row justify-content-center">
							<div class="col-md-12 mb-3">
								<label for="email" class="widthFull text-center">
									<h5 class="Regular black widthFull text-center">Inserisci l'indirizzo email che hai inserito in fase di registrazione, e clicca Invia</h5>
									<p class="Regular black widthFull text-center mt-3">Ti sarà inviata una email con il link per recuperare la tua password.</p>
								</label>
							</div>
							<div class="col-md-12 mb-3">
								<div class="group custInput " :class="{'inputHSD': brand == 'HAPPYBONUS' }">
									<input type="text" v-model="username" class="form-control"  id="username" name="username" data-vv-as="Email" v-validate="{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}" :class="{ 'is-invalid': errors.has('username'),valid: !!username }">
									<span class="highlight"></span>
									<span class="bar"></span>
									<label class="niceInputLabel" for="username">Email</label>

									<div v-if="errors.has('username')" class="invalid-feedback">
										{{ errors.first("username") }}
									</div>
									<div v-if="error" class="mb-3 text-left">
										<span class="errorMes ml-1">{{error}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="form-row justify-content-center">


							<div class="col-md-12 mb-3 mt-3 text-center ">
								<button class="btn btn-primary btm-lg" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" type="submit">Invia</button>
							</div>
						</div>
					</div>
					<div v-else="!state" >
						<div class="form-row justify-content-center">
							<div class="col-md-12 mb-3 mt-3">
								<h5 for="email" class="center pl-4 pr-4" role="alert">
									<p class="black">Ti è stata inviata una mail con il link per reimpostare la tua password di accesso,controlla nella tua posta in arrivo.</p>
									<p class="black">Se non dovessi trovarla controlla anche nella casella spam.</p>

								</h5>
							</div>
						</div>
						<div class="form-row justify-content-center">
							<div class="col-md-12 mb-3 text-center">
								<router-link class="btn btn-primary btn-lg mt-4" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" to="/">Continua</router-link>
							</div>
						</div>
					</div>

				</form>

			</div>

	  </div>
		</div>
	</div>
</template>

<script>
  import {AUTH_REQUEST} from 'actions/auth'
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'forgotpassword',
		components: {
		},
    data () {
      return {
        username: '',
		state: false,
		error: '',
		loading: false,
    brand: process.env.BRAND,
      }
    },
    methods: {
      forgot: function () {
        const { username } = this
				this.$validator.validate().then(valid => {
					if (valid) {
						this.loading = true
						axios({
							url: process.env.ROOT_API + 'fapi/send_forgot_pass_email',
							data: {
								email: username
							},
							method: 'POST',
							headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
						.then(resp => {
							if ( resp.data.error == "" ){
								this.state = true;

							}
							if ( resp.data.error == "email_not_present" ){
								this.state = false;
								this.error = process.env.MSG_EMAIL_NOT_FOUND
							}

							if ( resp.data.error == "account_not_confirmed" ){
								this.state = false;
								this.error = 'Attenzione! Non hai confermato il tuo account'
							}
							this.loading = false

						})
						.catch(resp => {
							this.state = false;
							this.error = process.env.MSG_EMAIL_NOT_FOUND
							this.loading = false
						})
					}
				})
      }
    },
    mounted: function() {
      this.$scrollTo('#app', 700, {
        offset: -775
      })
    },

	computed: {
      ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        //login_error: state => `${state.login_error}`,
      })
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/forgotpassword/index.vue